<template>
    <div
        class="bg-white mt-3 activity-type-create activity-template-view col-12"
    >
        <div class="form-sample p-3">
            <div class="d-flex title-bar-block">
                <div class="icon-block me-4">
                    <button
                        v-b-tooltip.hover
                        :title="$backLabel()"
                        @click="cancel()"
                    >
                        <i
                            class="fa fa-chevron-left text-white"
                            aria-hidden="true"
                        ></i>
                    </button>
                </div>
                <div class="text">
                    <span class="me-2">{{
                        $translate('activity_template')
                    }}</span>
                </div>
            </div>
            <b-tabs card v-model="tabIdx" class="mt-2" align="center">
                <b-overlay :show="loading" rounded="sm">
                    <b-tab :title="$translate('summary')" active class="p-0 mt-3">
                        <b-card no-body>
                            <b-form
                                class="form-sample"
                                @submit.stop.prevent="onSubmit"
                            >
                                <!-- disable input fields when the user can only view and not update  -->
                                <b-row>
                                    <b-col class="dd">
                                        <label class="mb-3"
                                            ><strong
                                                >{{ $translate('category') }}
                                                <span class="red">*</span></strong
                                            ></label
                                        >
                                        <b-form-select
                                            class="form-control"
                                            id="input-order_category_id"
                                            v-model="model.order_category_id"
                                            required
                                            v-custom-validation="$selectRequired()"
                                            :options="
                                                categories.map(x => ({
                                                    value: x.id,
                                                    text: x.name,
                                                }))
                                            "
                                            :disabled="canView"
                                        >
                                            <template #first>
                                                <b-form-select-option
                                                    :value="null"
                                                    disabled
                                                    >{{
                                                        $translate(
                                                            'select_category'
                                                        )
                                                    }}</b-form-select-option
                                                >
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col class="mt-3">
                                        <label class="mb-3"
                                            ><strong
                                                >{{ $translate('name') }}
                                                <span class="red">*</span></strong
                                            ></label
                                        >

                                        <b-form-input
                                            type="text"
                                            id="input-name"
                                            v-model="model.name"
                                            v-custom-validation="$textRequired()"
                                            required
                                            :placeholder="$translate('enter_name')"
                                            trim
                                            :disabled="canView"
                                        ></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col class="mt-3">
                                        <label class="mb-3"
                                            ><strong>{{
                                                $translate('description')
                                            }}</strong></label
                                        >
                                        <b-form-input
                                            type="text"
                                            id="input-description"
                                            v-model="model.description"
                                            :placeholder="
                                                $translate('enter_description')
                                            "
                                            trim
                                            :disabled="canView"
                                        ></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col class="mt-3 dd">
                                        <label class="mb-3"
                                            ><strong
                                                >{{ $translate('primary_type') }}
                                                <span class="red">*</span></strong
                                            ></label
                                        >

                                        <b-form-select
                                            class="form-control"
                                            id="input-order_type_id"
                                            v-model="model.order_type_id"
                                            required
                                            v-custom-validation="$selectRequired()"
                                            :options="primaryTypes"
                                            :disabled="canView"
                                        >
                                            <template #first>
                                                <b-form-select-option
                                                    :value="null"
                                                    disabled
                                                    >{{
                                                        $translate(
                                                            'select_primary_type'
                                                        )
                                                    }}</b-form-select-option
                                                >
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col class="my-3 dd">
                                        <label class="mb-3"
                                            ><strong>{{
                                                $translate('secondary_type')
                                            }}</strong></label
                                        >
                                        <b-form-select
                                            class="form-control"
                                            id="input-secondary_order_type_id"
                                            v-model="model.secondary_order_type_id"
                                            :options="secondaryTypes"
                                            :disabled="!isSecondaryTypeValid"
                                        >
                                            <template #first>
                                                <b-form-select-option
                                                    :value="null"
                                                    >{{
                                                        $translate(
                                                            'no_secondary_type'
                                                        )
                                                    }}</b-form-select-option
                                                >
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-col md="12" class="mb-2 mt-3 text-center">
                                    <!-- render the sumbit button only if the user can create and/or update -->
                                    <b-button
                                        class="btn btn-info btn-fw me-2"
                                        type="submit"
                                        v-if="hasPermissionCreate && !model.id"
                                        variant="primary"
                                        :disabled="loading ? true : false"
                                        >{{ createLabel }}</b-button
                                    >
                                    <b-button
                                        class="btn btn-info btn-fw me-2"
                                        type="submit"
                                        v-if="hasPermissionUpdate && model.id"
                                        variant="primary"
                                        :disabled="loading ? true : false"
                                        >{{ updateLabel }}</b-button
                                    >
                                    <b-button
                                        @click="deleteItem()"
                                        class="me-2"
                                        variant="delete-button"
                                        size="fw"
                                        v-if="hasPermissionDelete && this.model.id"
                                    >
                                        {{ $deleteLabel() }}
                                    </b-button>
                                    <b-button
                                        variant="info"
                                        size="fw"
                                        :disabled="loading ? true : false"
                                        @click="cancel()"
                                        >{{ $cancelLabel() }}</b-button
                                    >
                                </b-col>
                            </b-form>
                        </b-card>
                    </b-tab>

                    <b-tab
                        :title="$translate('primary_items')"
                        class="p-0 mt-3"
                        :disabled="!template.order_type_id"
                    >
                        <b-card-body class="p-0">
                            <template-items
                                v-if="tabIdx === 1"
                                :is-secondary-order-type="false"
                            />
                        </b-card-body>
                    </b-tab>
                    <b-tab
                        :title="$translate('secondary_items')"
                        class="p-0 mt-3"
                        :disabled="!template.secondary_order_type_id"
                    >
                        <b-card-body class="p-0">
                            <template-items
                                v-if="tabIdx === 2"
                                :is-secondary-order-type="true"
                            />
                        </b-card-body>
                    </b-tab>
                </b-overlay>
            </b-tabs>
        </div>
    </div>
</template>
<script>
import TemplateItems from './TemplateItems'
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'

const modelKeys = [
    'id',
    'order_category_id',
    'name',
    'description',
    'order_type_id',
    'secondary_order_type_id',
]

export default {
    name: 'activityTemplates-ViewItem',
    mixins: [permissionsMixins, popupMixins],
    components: {
        TemplateItems,
    },
    data() {
        return {
            model: {},
            loading: false,
            hasErrors: false,
            tabIdx: 0,
        }
    },
    computed: {
        componentName() {
            return this.$translate('activity_template')
        },
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            return !this.model.id &&
                this.user_permissions.includes('create.order.templates')
                ? true
                : false
        },
        /**
         * True if the user has permission to view but not update an order template and clicked the view button on a template in the table, otherwise false.
         */
        canView() {
            return this.model.id &&
                !this.user_permissions.includes('update.order.templates') &&
                this.user_permissions.includes('view.order.templates')
                ? true
                : false
        },
        /**
         * True if the user has permission to update an order template and clicked the view button on a template in the table, otherwise false.
         */
        canUpdate() {
            return this.model.id &&
                this.user_permissions.includes('update.order.templates')
                ? true
                : false
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },

        template() {
            return this.$store.state.orderTemplate.selectedTemplate
        },
        categories() {
            return this.$store.state.orderCategory.categories
        },
        types() {
            return this.$store.state.orderType.items
        },
        selected_trans_type() {
            const {
                model: { order_type_id },
                types,
            } = this
            return (
                (types.find(x => x.id == order_type_id) || {})
                    .transaction_type || {}
            )
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },

        entities() {
            return this.$store.getters['transactionType/entities']
        },

        flows() {
            return this.$store.getters['transactionType/flows']
        },
        primaryTypes() {
            const { types } = this
            return types.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
        secondaryTypes() {
            const { types, entities, flows } = this
            return types
                .filter(
                    x =>
                        x.transaction_type &&
                        ((x.transaction_type.reference_entity ==
                            entities.Customer &&
                            x.transaction_type.entity == entities.Officer &&
                            x.transaction_type.flow == flows.Outbound) ||
                            (x.transaction_type.entity == entities.Customer &&
                                x.transaction_type.reference_entity ==
                                    entities.Internal &&
                                x.transaction_type.flow == flows.Inbound))
                )
                .map(x => ({
                    value: x.id,
                    text: x.name,
                }))
        },
        isSecondaryTypeValid() {
            const { selected_trans_type, entities, flows } = this
            return !!(
                selected_trans_type &&
                entities.Customer == selected_trans_type.entity &&
                flows.Outbound == selected_trans_type.flow
            )
        },
    },
    watch: {
        template: {
            handler: function (_val) {
                console.log('template-watch', _val)
                for (const key of modelKeys) {
                    this.$set(this.model, key, _val[key] || null)
                }
            },
            deep: true,
        },
        selected_trans_type: {
            handler: function (_val, prev) {
                if (prev.id) this.model.secondary_order_type_id = null
            },
            deep: true,
        },
    },
    mounted() {
        console.log('modell', this.model)
        // ensure that the selected template and model are cleared for a new template or updated with an existing template
        for (const key of modelKeys) {
            this.$set(this.model, key, this.template[key] || null)
        }
        console.log('template-mounted', this.model)
        console.log('entities', this.entities)
        console.log('flows', this.flows)
        console.log('types', this.types)
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        async onSubmit() {
            try {
                this.loading = true
                const model = { ...this.model }
                console.log('model', model)
                const action = model.id ? 'update' : 'create'
                const message = model.id
                    ? this.$translate('update_alert')
                    : this.$translate('create_alert')
                const path = `orderTemplate/${action}`
                const valid = await this.$validator.validate()
                if (!valid) throw new Error('Invalid')
                await this.$store.dispatch(path, model)
                if (action == 'create') this.tabIdx = 1
                this.$emit('success', action, model.name, message)
            } catch (error) {
                console.log('error', error.message)
                this.genericToast(
                    this.componentName,
                    this.$translate('error'),
                    'danger',
                    `${error}`
                )
            } finally {
                this.loading = false
            }
        },
        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'orderTemplate/delete'
            const action = model.id ? 'update' : 'create'

            // Generate and display confirmation prompt
            const title = this.$translate('delete_activity_templates')
            const message = `${this.$translate('delete_note')} ${model.name}?`
            // const errorMsg = 'Unable to delete Activity Template!'
            const alertMsg = this.$translate('delete_alert')
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.loading = true;
                    this.$store
                        .dispatch(path, model.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit(
                                'success',
                                this.$translate('deleted'),
                                model.name,
                                alertMsg,
                                action
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.loading = false;
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                        })
                } else {
                    this.loading = false;
                }
            })
        },
    },
}
</script>
<style></style>
